import { topicItems } from "@/mocks/gua";

const sizeCls: Record<string, string> = {
  lg: "px-4 py-2.5 text-sm md:px-5 md:py-3 md:text-base",
  md: "px-3.5 py-2 text-sm",
  sm: "px-3 py-1.5 text-xs",
};

export default function TopicWall() {
  return (
    <section id="topics" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="wrap">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-price-tag-3-fill" aria-hidden="true"></i>
              话题墙 · 持续更新
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              正在发酵的话题<span className="text-primary-500">都在这里</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              每个标签背后都有对应的时间线与前因后果背景解析，点进去从源头开始吃。
            </p>
          </div>
        </div>

        <div className="mt-7 flex flex-wrap items-center gap-3">
          {topicItems.map((t) => (
            <a
              key={t.name}
              href="#analysis"
              className={
                "group inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-100/60 font-medium text-foreground-800 transition-colors hover:border-accent-300 hover:bg-accent-50 hover:text-accent-900 " +
                (sizeCls[t.size] ?? sizeCls.sm)
              }
            >
              <span className="text-accent-600">{t.name}</span>
              <span className="flex items-center gap-0.5 text-xs text-foreground-400">
                <i className="ri-fire-line" aria-hidden="true"></i>
                {t.count}万
              </span>
            </a>
          ))}
          <a
            href="#feed"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-dashed border-foreground-400 px-3 py-1.5 text-xs text-foreground-500 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-add-line" aria-hidden="true"></i>
            查看全部话题
          </a>
        </div>

        {/* 话题速览分类条 */}
        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {[
            { icon: "ri-music-2-line", name: "音乐瓜", desc: "假唱、翻唱、舞台现场", color: "bg-primary-100 text-primary-800" },
            { icon: "ri-live-line", name: "直播瓜", desc: "带货、翻车、选品争议", color: "bg-secondary-100 text-secondary-900" },
            { icon: "ri-clapperboard-line", name: "综艺影视瓜", desc: "剪辑、番位、口碑风向", color: "bg-accent-100 text-accent-800" },
            { icon: "ri-gamepad-line", name: "电竞瓜", desc: "转会、合同、战队动向", color: "bg-primary-100 text-primary-800" },
          ].map((c) => (
            <div key={c.name} className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-100/50 p-4">
              <span className={"flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl " + c.color}>
                <i className={c.icon} aria-hidden="true"></i>
              </span>
              <div>
                <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                <div className="mt-0.5 text-xs text-foreground-500">{c.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}